import React from "react";
import { Header } from "@tvg/design-system";
import TableSlot from "../TableSlot";
import { TableProps } from "../../types";
import {
  TableComponentWrapper,
  ScrollableIndicator
} from "./styled-components";

export interface TableContentProps {
  content: TableProps;
}

const defaultContent: TableProps = {
  title: "",
  description: "",
  tableContent: []
};

/* eslint-disable no-underscore-dangle */

const TableContent = ({ content = defaultContent }: TableContentProps) => {
  // TODO - this is a temporary guard until this component is worked on
  if (!content || (!content.title && !content.description)) {
    return null;
  }

  return (
    <>
      <TableComponentWrapper>
        {content.title && (
          <Header tag="h3" fontSize={14}>
            {content.title}
          </Header>
        )}
        {content.description && (
          <Header tag="h2" fontSize={16}>
            {content.description}
          </Header>
        )}
        {content.tableContent.map((row) => (
          <TableSlot key={row._uid} content={row} />
        ))}
      </TableComponentWrapper>
      <ScrollableIndicator length={content.tableContent.length} />
    </>
  );
};

export default TableContent;
